"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = _interopRequireDefault(require("./styles"));

var ListContainer = _styles["default"].ListContainer;

var List = function List(props) {
  var items = props.items,
      _onClick = props.onClick;
  return /*#__PURE__*/_react["default"].createElement(ListContainer, null, items.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: i,
      onClick: function onClick() {
        return _onClick(i);
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      alt: "item-img",
      src: item.imageUrl
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "details"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "title"
    }, /*#__PURE__*/_react["default"].createElement("p", null, item.name), item.SubTitle && /*#__PURE__*/_react["default"].createElement("p", {
      className: "subTitle"
    }, item.subTitle)), /*#__PURE__*/_react["default"].createElement("i", {
      className: "far fa-chevron-right"
    })));
  }));
};

var _default = List;
exports["default"] = _default;